import React, { useState } from "react";
import { WizardView, WizardContextProvider } from "../Wizard";
import { timeString } from "../../utils";
import moment from "moment";
import IonRangeSlider from "react-ion-slider";
import classNames from "classnames";
import Select from "react-select";

function AddDeviceProfileWizard(props) {
    const [name, setName] = useState();
    const [description, setDescription] = useState();
    const [provisioningStrategyId, setProvisioningStrategyId] = useState();

    return (
        <WizardContextProvider
            onClose={props.onClose}
            onFinish={props.onFinish}
            title={"Add New Device Profile"}
        >
            <WizardView.Page
                title="Details"
                onNextRequested={(e) => {
                    console.log(e.detail.manifest);
                    e.detail.manifest = {
                        ...e.detail.manifest,
                        ...(name && { name }),
                        ...(description && { description }),
                    };
                    e.detail.prevented = !name || name == "";
                    console.log(e);
                }}
            >
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Name and Description</h3>
                    </div>
                    <div class="card-body">
                        <p>
                            A{" "}
                            <span class="badge badge-primary">
                                <i className="fa fa-sd-card"></i> Device Profile
                            </span>{" "}
                            establish standards of devices that will latch to
                            the system. A Device Profile is used to issue a
                            configuration to the device at startup
                        </p>
                        <p>
                            Provide a name for the Device Profile. The name
                            specified here will be used to identify the. For
                            instance, <b>&quot;Work Station&quot;</b>
                        </p>

                        <div className="form-group">
                            <label htmlFor="dp.name">Name</label>
                            <input
                                id="dp.name"
                                type="text"
                                className={classNames("form-control", {
                                    "is-invalid": !name || name == "",
                                })}
                                placeholder="Name"
                                defaultValue={name}
                                onChange={(e) => {
                                    setName(e.target.value);
                                }}
                            />
                        </div>
                        <p>
                            You may, optionally, provide a description for your
                            new Device Profile
                        </p>
                        <div className="form-group">
                            <label htmlFor="device.description">
                                Description
                            </label>
                            <input
                                type="textarea"
                                className="form-control"
                                rows={3}
                                defaultValue={description}
                                onChange={(e) => {
                                    setDescription(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div class="card-footer"></div>
                </div>
            </WizardView.Page>

            <WizardView.Page
                title="Provisioning"
                onNextRequested={(e) => {
                    e.detail.manifest = {
                        ...e.detail.manifest,
                        ...(provisioningStrategyId && {
                            provisioning_strategy_id: provisioningStrategyId,
                        }),
                    };
                    console.log(e);
                }}
            >
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Setup Provisioning</h3>
                    </div>

                    <div class="card-body">
                        <p>Choose a Provisioning Strategy</p>
                        <div
                            class="form-check"
                            onChange={(e) => {
                                setProvisioningStrategyId(
                                    parseInt(e.target.value)
                                );
                            }}
                        >
                            <input
                                class="form-check-input"
                                type="radio"
                                name="dp.provisioning_strategy"
                                value="1"
                                defaultChecked={
                                    provisioningStrategyId == null ||
                                    provisioningStrategyId == 1
                                }
                            />
                            <label class="form-check-label">
                                Device Based Provisioning (Default)
                            </label>
                            <div>
                                <small>
                                    The device will be provisioned with the
                                    signals that it reports when powered on.
                                </small>
                            </div>
                            <div>&nbsp;</div>
                            <input
                                class="form-check-input"
                                type="radio"
                                name="dp.provisioning_strategy"
                                value="2"
                                defaultChecked={provisioningStrategyId == 2}
                            />

                            <label class="form-check-label">
                                Profile Based Provisioning
                            </label>
                            <div>
                                <small>
                                    The device will report its signals at
                                    startup but will be instructed to use the
                                    configuration specified in the device
                                    profile. <br />
                                    You will be able to configure the overriding
                                    behavior when you customize this profile
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer"></div>
                </div>

                <hr></hr>
                <div className="row">
                    <div className="col-lg-9"></div>
                </div>
                <div className="col-lg-12 setShiftContianer">
                    <div className="setShift" id="shift_container"></div>
                </div>
            </WizardView.Page>
            <WizardView.Page title="Finish">
                <p>Great! It seems we have the required information!</p>
                <p>
                    <b>You can setup this profile once it is created</b>
                </p>
                <p>
                    Click on Finish to setup your{" "}
                    <span class="badge badge-primary">
                        <i className="fa fa-sd-card"></i> Device Profile
                    </span>{" "}
                </p>
            </WizardView.Page>
        </WizardContextProvider>
    );
}

export default AddDeviceProfileWizard;
